<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">PIN verification</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="mb-3">
        <label for="dateOfBirth">Enter PIN Number :<span style="color: brown;">{{addbalance}}</span></label>
        <div class="input-group">
          <input type="number" id="dateOfBirth" class="form-control" placeholder="mobile number" name="dp" [(ngModel)]="mobileNumber">
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submit()" >SUBMIT</button>
  </div>